import styled from "styled-components";

export const ContactDetailsContainer = styled.div`
  .details-page-top-btn {
    height: 35px;
    display: flex;
    border-bottom: 1px solid #ebedf2;
    justify-content: space-between;
    @media (max-width: 575.98px) { 
        flex-direction: column;
        height: unset;
        padding-bottom: 4px;
    }
    .left-side-btn {
      display: flex;
      align-items: center;
      padding: 15px;
      @media (max-width: 575.98px) { 
        padding: 8px;
      }
      .back-btn {
        cursor: pointer;
      }
      span {
        margin-left: 10px;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .ledger {
      padding: 2px !important;
      width: 26px;
      height: 26px;
      border-color: #000;
      img{
        width: 16px;
        height: 18px;
      }
    }  
    .right-side-btn {
      display: flex;
      align-items: center;
      margin-right: 15px;
      @media (max-width: 575.98px) { 
        justify-content: end;
        margin-right: 10px;
      }
      .customBtn {
        margin: 0 3px;
        padding: 4px 6px;
        @media (max-width: 575.98px) { 
          padding: 5px 8px;
        }
        svg{
          width: 13px;
          height: 13px;
        }
      }
      .bg-blue {
        background-color: #36a3f7;
        color: #fff;
        &:hover {
          border: 1px solid #36a3f7;
        }
      }

      .bg-green {
        background-color: #34bfa3;
        color: #fff;
        &:hover {
          border: 1px solid #34bfa3;
        }
      }

      .bg-yellow {
        background-color: #ffb822;
        color: #fff;
        &:hover {
          border: 1px solid #ffb822;
        }
      }

      .bg-red {
        background-color: #f4516c;
        color: #fff;
        &:hover {
          border: 1px solid #f4516c;
        }
      }
    }
  }

  .details-tab {
    /* margin-top: 10px; */
    .MuiTabs-scroller{
      @media (max-width: 575.98px) { 
        overflow-x: scroll !important;
      }
      button {
        @media (max-width: 575.98px) { 
          margin: 0 5px;
        }
      }
    }
  }
`;
